import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import { Search, MapPin, Hotel, Image } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

interface PortfolioItem {
  id: string;
  title: string;
  location: string;
  category: string;
}

export const SearchCommand = () => {
  const [open, setOpen] = useState(false);
  const [portfolioItems, setPortfolioItems] = useState<PortfolioItem[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Load portfolio items
    const loadItems = async () => {
      const { data } = await supabase
        .from('portfolio_items')
        .select('id, title, location, category')
        .order('title');
      
      if (data) setPortfolioItems(data);
    };
    loadItems();
  }, []);

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
      if (e.key === '/' && !open) {
        e.preventDefault();
        setOpen(true);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, [open]);

  const handleSelect = (itemId: string) => {
    setOpen(false);
    navigate(`/portfolio?item=${itemId}`);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search hotels, locations..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Hotels">
          {portfolioItems.map((item) => (
            <CommandItem
              key={item.id}
              value={`${item.title} ${item.location} ${item.category}`}
              onSelect={() => handleSelect(item.id)}
            >
              <Hotel className="mr-2 h-4 w-4" />
              <span>{item.title}</span>
              <span className="ml-auto text-xs text-muted-foreground flex items-center">
                <MapPin className="mr-1 h-3 w-3" />
                {item.location}
              </span>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};
